import React from 'react';
import './ConsentToEstablish.css';
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import cte_dummy_1 from '../../assets/images/cte-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_cte_banner from '../../assets/images/img_peso1_banner.png';
import { FaBuilding, FaFileAlt, FaBalanceScale, FaCogs, FaComments, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function ConsentToEstablish() {
  const cteBenefits = [
    {
      icon: <FaBuilding />,
      title: 'Project Approval',
      text: 'Secure legal approval to commence your business operations.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Regulatory Compliance',
      text: 'Ensure compliance with pollution control regulations.',
    },
    {
      icon: <FaBalanceScale />,
      title: 'Legal Protection',
      text: 'Avoid penalties and legal issues by obtaining CTE in advance.',
    },
    {
      icon: <FaCogs />,
      title: 'Operational Readiness',
      text: 'Streamline your setup process with proper permissions.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Discuss your project and its environmental impact.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Document Preparation',
      description: 'Gather and prepare all necessary documentation.',
    },
    {
      icon: <FaBuilding />,
      title: 'Site Inspection',
      description: 'Conduct inspections to ensure compliance with guidelines.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the CTE application to the pollution control board.',
    },
    {
      icon: <FaCertificate />,
      title: 'Approval Issuance',
      description: 'Receive Consent to Establish and proceed with your project.',
    },
  ];

  const acts = [
    "Water (Prevention and Control of Pollution) Act, 1974",
    "Air (Prevention and Control of Pollution) Act, 1981",
    "Environment Protection Act, 1986"
  ];

  const explanation = "These acts ensure that projects adhere to environmental standards, minimize pollution, and promote sustainable development.";

  const checklistItems = [
    { name: 'Project Layout Plan', description: 'Submit a detailed layout of your project site.' },
    { name: 'Environmental Impact Report', description: 'Provide a report outlining the environmental implications of the project.' },
    { name: 'NOC from Local Authorities', description: 'Submit a no-objection certificate from relevant local bodies.' },
    { name: 'Pollution Control Measures Plan', description: 'Document detailing your strategies for controlling pollution.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Consent to Establish (CTE) Services"
        subheading="Get your business set up with the necessary environmental permissions."
        ctaPrimary={{ text: "Request Consultation", link: "/contact-us" }}
        ctaSecondary={{ text: "Learn More", link: "/consent-to-estalish" }}
        backgroundImage={cte_dummy_1}
      />

      <ServicesOverviewSection
        title="What is Consent to Establish (CTE)?"
        description="Consent to Establish is a mandatory approval issued by pollution control boards to ensure environmental and regulatory compliance before starting any industrial or development project."
        image={img_cte_banner}
        altText="CTE Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Consent to Establish"
        description="Learn how obtaining Consent to Establish ensures compliance and smooth project initiation."
        benefits={cteBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Environmental Regulations for Project Approval"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple CTE Approval Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="CTE Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
